<template>
  <div class="detile">
    <el-Card >
    <div class="carBOX">
         <div> 是否开通短信
      <el-switch v-model="codePhone" @change="codeChange"></el-switch>一天最多发送
      <el-input-number v-model="conunt" @change="handleChange" :min="1" :max="999" label="描述文字"></el-input-number>次 间隔
      <el-input-number v-model="horme" @change="handleChange" :min="1" :max="999" label="描述文字" />小时</div>
      <div>
         <el-button type="primary" size="mini" icon="el-icon-s-custom">确定</el-button>
      </div>
    </div>
    </el-Card>

      <div class="table">
           <el-table
      :data="tableData"
      style="width: 100%"
      border>
      <el-table-column
        prop="date"
        label="真实姓名"
       >
      </el-table-column>
      <el-table-column
        prop="name"
        label="用户类型"
       >
      </el-table-column>
      <el-table-column
        prop="address"
        label="手机号">
      </el-table-column>
       <el-table-column
        prop="address"
        label="固定电话">
      </el-table-column>
       <el-table-column
        prop="address"
        label="注册时间">
      </el-table-column>
    </el-table>
      </div>
    <div style="text-align: center;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="deterMine">确 定</el-button>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    closefale: {
      type: Function,
      default: Function
    }
  },
  data() {
    return {
      codePhone: true,
      conunt: 0,
      horme:0,
       tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀'
          }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区'
          }]
    };
  },
  methods: {
    //   确定
    deterMine() {
        this.closefale()
    },
    //取消
    cancelClick() {
          this.closefale()
    },
    //监听是否点击了开关
    codeChange(e) {
      if (e) {
        this.$message.success("开通短信");
      } else {
        this.$message.success("取消开通短信");
      }
    },
    handleChange(){},
  }
};
</script>
<style  scoped>
.content {
  width: 100%;
  padding-bottom: 30px;
}
.url {
  padding-bottom: 10px;
}
.content el-inpu {
  width: 100%;
}
.carBOX{
    display: flex;
    align-items: center;
    justify-content: space-around;
    /* text-align:center; */
}
.table{
    padding: 10px 0;
}
</style>